import { Container, StyledRadioButton } from './RadioButton.styles';
import React from 'react';
import { StyledLabel } from 'src/components/foundations/foundations.styles';

interface Props {
  checked?: boolean;
  label?: string;
  labelPosition?: string;
  disabled?: boolean;
  readOnly?: boolean;
  'data-testid'?: string;
  id: string;
  name?: string;
  defaultChecked?: boolean;
  placeholder?: string;
  onClick: React.MouseEventHandler<HTMLInputElement>;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

export const RadioButton = ({
  checked,
  label,
  labelPosition = 'left',
  disabled,
  onChange,
  readOnly,
  ...props
}: Props) => {
  const readOnlyForControlled =
    readOnly ?? (checked !== undefined && onChange === undefined);

  return (
    <Container>
      {label && labelPosition === 'left' && (
        <StyledLabel disabled={disabled}>
          {label ?? props.placeholder}
        </StyledLabel>
      )}
      <StyledRadioButton
        disabled={disabled}
        checked={checked}
        onChange={onChange}
        readOnly={readOnlyForControlled}
        {...props}
      />
      {label && labelPosition === 'right' && (
        <StyledLabel disabled={disabled}>
          {label ?? props.placeholder}
        </StyledLabel>
      )}
    </Container>
  );
};
